import { connect } from 'react-redux';

import { getIdentitiesAndContacts, setSelectedContact } from '../actions/ChoiceActions';
import { sendOtp } from '../actions/OtcActions';

import ChoiceView from '../components/Steps/Choice/ChoiceView';

const mapStateToProps = state => ({
  identitiesId: state.identification.identitiesId,
  contacts: state.contacts,
  isFetching: state.choice.isFetching,
  identities: state.choice.identities,
  webViewMode: state.generic.webViewMode,
});

const mapDispatchToProps = dispatch => ({
  getIdentitiesAndContacts: () => dispatch(getIdentitiesAndContacts()),
  setSelectedContact: contact => dispatch(setSelectedContact(contact)),
  sendOtp: ({ contact }) => dispatch(sendOtp({ contact })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChoiceView);
